module.exports = __webpack_public_path__ + "img/layoutRightWhite.ec849ac2.svg";